import { render, staticRenderFns } from "./OATaskList.vue?vue&type=template&id=12c8e7de&scoped=true"
import script from "./OATaskList.vue?vue&type=script&lang=js"
export * from "./OATaskList.vue?vue&type=script&lang=js"
import style0 from "./OATaskList.vue?vue&type=style&index=0&id=12c8e7de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c8e7de",
  null
  
)

export default component.exports